import React from 'react';
import heroImage from '../assets/photography.jpg';

const HeaderPhoto = () => {
	return <img src={heroImage} alt="photogrpahy" className="header-photo" />;
};

export default HeaderPhoto;
